import DeviceConflictModal from './DeviceConflictModal';

export default DeviceConflictModal;
